import Vue from "vue";
import App from "./App.vue";
import { ir } from "./check_domain_ir";
import router from "./router";
import store from "@/core/services/store";
// import ApiService from "@/core/services/api.service";
// import MockService from "@/core/mock/mock.service";
import "material-design-icons/iconfont/material-icons.css";
// import modal from '@/core/plugins/EasyModal/index';
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import DataTable from "laravel-vue-datatable";
import ClipboardJS from "clipboard";
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
Vue.use(VueTelInput);

//custom
import "./custom";
import moment from "moment-jalaali";
import axios from "axios";
import TerminalTitleRibbon from "./core/plugins/TitleRibbon/install";
import mobileTable from "./core/plugins/mobileTable/src/install";

Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com/#/login");
Vue.prototype.$panelcore = ir("https://core_panel.terminalads.com");
Vue.prototype.$terminal = ir(".terminalads.com");
Vue.prototype.$coreApi3 = ir("https://api.terminalads.com");
Vue.prototype.$coreApi2 = ir("https://api.terminalads.com/api");
Vue.prototype.$coreApi = ir("https://core.terminalads.com");
Vue.prototype.$qrApi = ir("https://qr-api.terminalads.com/api");
Vue.prototype.$mediaApi = ir("https://media.terminalads.com");
Vue.prototype.$linkApi = ir("https://link.terminalads.com");
Vue.prototype.$robotApi = ir("https://robot-api.terminalads.com/api");
Vue.prototype.$payamakApi = ir("https://sms-api.terminalads.com/api");
Vue.prototype.$payamakApi2 = ir("https://sms-api.terminalads.com/api/");
Vue.prototype.$coreLogin = ir("https://core.terminalads.com/#/login");
Vue.prototype.$fileApi = ir("https://file-api.terminalads.com/api");
Vue.prototype.$fileApi2 = ir("https://file-api.terminalads.com/api/");
Vue.prototype.$corepayamakApi = ir("https://core-sms.terminalads.com");
Vue.prototype.$terminalads = ir("https://terminalads.com");
Vue.prototype.$coreqrOrigin = ir("core-qr.terminalads.com");
Vue.prototype.$robotCoreApi = ir("https://core-robot.terminalads.com");
Vue.prototype.$coreqrApi = ir("https://core-qr.terminalads.com");
Vue.prototype.$digiApi = ir("https://core-digi.terminalads.com");

Vue.prototype.$assets = {
  logo: ir(
    "https://api.terminalads.com/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
  ),
};
Vue.prototype.$services = {
  1: ir("https://core.terminalads.com"),
  2: ir("https://core-sms.terminalads.com"),
  3: ir("https://core-qr.terminalads.com"),
  4: ir("https://core-robot.terminalads.com"),
  5: ir("https://core-billboard.terminalads.com"),
  10: ir("https://core-info.terminalads.com"),
  11: ir("https://core-file.terminalads.com"),
  13: ir("https://core-digi.terminalads.com"),
  14: ir("https://core-graphic.terminalads.com"),
};

const Vue1 = Vue;
Vue.mixin({
  methods: {
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    onlyNumber(e) {
      if (e.charCode < 48 || e.charCode > 57) e.preventDefault();
    },
    persian(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      return str1;
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
  },
  computed: {
    wallet() {
      return this.$store.getters["wallet/wallet"];
    },
  },
});

Vue.prototype.can = (value) => {
  const abilities = store.state.ability;

  return (
    abilities.indexOf(value + ":active") >= 0 ||
    abilities.indexOf(value + ":show") >= 0
  );
};

Vue.config.productionTip = false;

// start filters
Vue.filter("currency", (x) => {
  return x ? new Intl.NumberFormat("en-US", { style: "decimal" }).format(x) : 0;
});

Vue.filter("timeAgo", (value) => moment(value).fromNow());

Vue.filter("longDate", (value) => moment(value).format("HH:mm jYYYY-jM-jD"));

Vue.filter("rial", (value) =>
  value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
);

Vue.filter("stringDate", function (input) {
  try {
    // let moment = require('moment-jalaali')
    moment.locale("fa", null);
    moment.loadPersian({ dialect: "persian-modern" });
    return moment(input, "YYYY-M-D HH:mm:ss").format("dddd LL HH:mm:ss");
  } catch (e) {}
});

Vue.filter("persianNum", function (input) {
  try {
    if (input === undefined || input == null) return "";
    let str1 = input.toString().trim();
    if (str1 === "") return "";
    str1 = str1.replace(/0/gim, "۰");
    str1 = str1.replace(/1/gim, "۱");
    str1 = str1.replace(/2/gim, "۲");
    str1 = str1.replace(/3/gim, "۳");
    str1 = str1.replace(/4/gim, "۴");
    str1 = str1.replace(/5/gim, "۵");
    str1 = str1.replace(/6/gim, "۶");
    str1 = str1.replace(/7/gim, "۷");
    str1 = str1.replace(/8/gim, "۸");
    str1 = str1.replace(/9/gim, "۹");
    return str1;
  } catch (e) {}
});

Vue.filter("userType", (value) => {
  if (value === "legal") return "شخص حقوقی";
  return "شخص حقیقی";
});

Vue.filter("isEmpty", (val) => {
  return val ? val : "";
});

Vue.filter("serviceType", (val) => {
  if (val === "Payamakland") return "پیامک لند";
  else if (val === "Coreland") return "کورلند";
  else if (val === "Qrland") return "کیوآر لند";
  else if (val === "Robotland") return "ربات لند";
  else if (val === "billboard") return "بیلبورد";
  else if (val === "tablighNegar") return "تبلیغ نگار";
  else return "نامعلوم";
});

Vue.filter("persianNumber", (value) => {
  return value.toPersianLetter();
});

Vue.filter("numericPersianNumber", (value) => {
  if (value < 1_000_000) return value / 1_000 + " هزار";
  return value / 1_000_000 + " میلیون";
});
// end filters

window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
window.url = ir(process.env.VUE_APP_URL);
window.VuePersianDatetimePicker = VuePersianDatetimePicker;

export const Axios2 = axios.create({
  baseURL: url,
  timeout: 15000,
  headers: {
    Authorization: localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

const extra = Axios2.get("/user/more").then((res) => {
  return {
    announcement: res.data.data.advertises,
    numbers: res.data.data.numbers,
  };
});
Vue.use(mobileTable);
Vue.use(TerminalTitleRibbon, {
  store,
  axios,
  config: () => ({
    dashboardConfig: {
      announcement: {
        img: "/online-shopping-list-5622700-4689003.png",
        text: "بانک های موجود",
        url: router.resolve({ name: "shop_archives" }).href,
      },
      numbers: {
        img: "/top-rated-buying-product-5045295-4204231.png",
        text: "بانک های خریداری شده",
        url: router.resolve({ name: "bought_archives" }).href,
      },
      counter: extra,
    },
    static_top_menu: [],
    header_logo: "/media/img/infoland.png",
  }),
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  permissions: () => store.state.ability,
  core_url: ir(process.env.VUE_APP_CoreLandUrl),
  front_url: ir(process.env.VUE_APP_CoreLandUrlFront),
  sid: 10,
});

export let dataTableProps = {
  tableProps: {
    search: "",
    length: 10,
    column: "id",
    dir: "desc",
    page: 1,
  },
  pagination: {
    align: "right",
    limit: 4,
  },
  translate: {
    nextButton: "بعدی",
    previousButton: "قبلی",
    rowsPerPageText: "تعداد در صفحه",
    noDataText: "داده ای برای نمایش وجود ندارد",
    placeholderSearch: "جستجو کنید..",
  },
};

// API service init
// ApiService.init();

// Remove this to disable mock API
// MockService.init();

// router.beforeEach((to, from, next) => {
//     // Ensure we checked auth before each page load.
//     Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);
//
//     // reset config to initial state
//     store.dispatch(RESET_LAYOUT_CONFIG);
//
//     // Scroll page to top on every route change
//     setTimeout(() => {
//         window.scrollTo(0, 0);
//     }, 100);
// });

Vue.use(DataTable);
// Vue.use(modal);
Vue.use(VuePersianDatetimePicker, {
  name: "date-picker",
  props: {
    autoSubmit: true,
    clearable: true,
  },
});

$("input[name='table-search']")
  .parent()
  .removeClass("offset-md-6")
  .addClass("ms-auto");

export const Bus = new Vue({
  data() {
    return {};
  },
  methods: {
    setProp(name, value) {
      this[name] = value;
    },
    getProp(name) {
      return this[name];
    },
  },
});

window.Vue = new Vue({
  data() {
    return {
      gotToken: false,
    };
  },
  router,
  store,
  i18n,
  vuetify,
  VuePersianDatetimePicker,
  render: (h) => h(App),
  methods: {
    fetch() {
      let result = null;

      $.ajax({
        url: url + "/user/abilities",
        async: false,
        fn: this.fetch,
        headers: {
          Authorization: Token,
          ACCEPT: "application/json",
        },
        success: (data) => {
          this.permissions();
          this.gotToken = true;
          this.$store.dispatch("global/isLoaded", true);
          this.$store.state.ability = data.data;
          result = data.data;
        },
      });

      return result;
    },
    permissions() {
      Vue.directive("status", (element, binding) => {
        const value = binding.value;
        const abilities = this.$store.state.ability;

        if (
          abilities.indexOf(value + ":active") < 0 &&
          abilities.indexOf(value + ":show") < 0
        ) {
          $(element).remove();
          return;
        }
        if (abilities.indexOf(value + ":show") > -1) {
          $(element).attr("disabled", true);
        }
      });
    },
    permissionRoutes() {
      router.beforeResolve((to, from, next) => {
        const permission = to.meta.permission;
        const abilities = this.gotToken
          ? this.$store.state.ability
          : this.fetch();

        if (to.path === "/dashboard") return next();

        if (
          (!Boolean(abilities) ||
            abilities.indexOf(permission + ":active") < 0) &&
          Boolean(permission)
        )
          next(from);

        next();
      });
    },
    getClock() {
      let clock = null;
      $.ajax({
        url: `${url}/setting/clock`,
        type: "GET",
        async: false,
        fn: this.getClock,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (val) => {
          clock = val.data;
        },
      });

      return clock;
    },
    getSpecialmenu() {
      $.ajax({
        url: `${url}/user/menus`,
        type: "GET",
        fn: this.getSpecialmenu,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.$store.dispatch("menu/items", data.data);
        },
      });
    },
  },
  mounted() {
    let url = window.location.href;
    const start = url.indexOf("?token=") + "?token=".length;
    const end = url.indexOf("#");
    let token = url.substring(start, end);

    if (start > 6) localStorage.setItem("id_token", token);

    if (localStorage.getItem("id_token"))
      window.Token = localStorage.getItem("id_token");

    this.permissionRoutes();

    if (start > 6) window.history.pushState("dashboard", "Title", "/");

    this.getSpecialmenu();
  },
}).$mount("#app");
